import { createSelector } from '@ngrx/store';

import { Coverage } from '@models/swagger';
import { State } from './reducer';
import { selectGetCoveragesState } from '../selectors';

export const getData = createSelector(selectGetCoveragesState, (state: State) => state.data);

export const getError = createSelector(selectGetCoveragesState, (state: State) => state.error);

export const getLoading = createSelector(selectGetCoveragesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: Coverage[]) => T) =>
  createSelector(selectGetCoveragesState, (state: State) => fn(state.data));
